export const REGIONS_SLICE = 'REGIONS_SLICE';
